<template>
  <t-text-input
    v-model="cep"
    :mask="'#####-###'"
    label="CEP"
    required
    hide-details="auto"
    @input="cep.length === 9 && validate()"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import TTextInput from "@/components/core/TTextInput.vue";

import Address from "@/types/Address";
import { zipcode } from "@/plugins/zipcode";

interface Props {
  modelValue?: string;
}

const { modelValue = "" } = defineProps<Props>();

const emit = defineEmits<{
  "update:modelValue": [value: string];
  "cep": [address: Address];
  "error": [message: string];
}>();

defineOptions({
  name: "TCepInput",
});

const cep = computed<string>({
  get(): string {
    return modelValue;
  },
  set(value: string) {
    emit("update:modelValue", value);
  },
});

async function validate(): Promise<void> {
  try {
    const validated = await zipcode(cep.value);

    emit("cep", {
      zipcode: validated.cep,
      neighborhood: validated.bairro,
      street: validated.logradouro,
      city: validated.localidade,
      state: validated.uf,
    } as Address);
  } catch (error) {
    emit("error", error as string);
  }
}
</script>
